(function() {
    "use strict";

    var tuxCurrencyFilter = function ($filter) {

        // Implemented in terms of Angular's currency filter.
        var currencyFilter = $filter('currency');

        return function (amount, symbol, showCents) {

            var result = amount;
            if (typeof(amount) === 'undefined' || amount == null) return result;
            if (!symbol) symbol = '$';

            var value = currencyFilter(amount, '');
            var cents = value.substring(value.length - 3, value.length);
                value = value.substring(0, value.length - 3);

            var htmlCents = '';
            if (showCents) {
                htmlCents = '<sup class="tux-money-cents">' + cents + '</sup>';
            }

            var result = '<span class="tux-money-amount">' +  value + '</span>' + htmlCents;
            if (symbol.length > 0)
                result = '<sup class="tux-money-symbol">' + symbol + '</sup>' + result;

            return result;
        }
    };

    webModule.filter('tuxCurrency', [ '$filter',tuxCurrencyFilter ]);
}());